<template>
  <div>
    <!-- ระดับน้ำปัจจุบัน -->
    <b-row cols="12">
      <b-col
        lg="12"
        md="12"
        sm="8"
        xs="8"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 402 227"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H389.2C393.68 0 395.921 0 397.632 0.871948C399.137 1.63893 400.361 2.86278 401.128 4.36808C402 6.07937 402 8.31958 402 12.8V214.2C402 218.68 402 220.921 401.128 222.632C400.361 224.137 399.137 225.361 397.632 226.128C395.921 227 393.68 227 389.2 227H12.8C8.31957 227 6.07937 227 4.36808 226.128C2.86278 225.361 1.63893 224.137 0.871948 222.632C0 220.921 0 218.68 0 214.2V12.8Z"
            fill="black"
            fill-opacity="0.59"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="65"
          >
            <div>
              <b-img
                height="32"
                src="@/assets/images/icons/bridge/Swim.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="75"
            y="60"
          >
            <div>
              <span style="font-size:28px; color: #fff;"> ระดับน้ำปัจจุบัน</span>
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="215"
            y="125"
          >
            <div>
              <span style="font-size:42px; color: #fff; font-weight: 600;"> {{ AVG_WT }} </span>
              <span style="font-size:28px; color: #fff;"> เมตร</span>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>

    <!-- ระดับน้ำสูงสุด ต่ำสุด -->
    <b-row
      cols="12"
    >
      <b-col>
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 128 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H115.2C119.68 0 121.921 0 123.632 0.871948C125.137 1.63893 126.361 2.86278 127.128 4.36808C128 6.07937 128 8.31958 128 12.8V83.2C128 87.6804 128 89.9206 127.128 91.6319C126.361 93.1372 125.137 94.3611 123.632 95.1281C121.921 96 119.68 96 115.2 96H12.8C8.31958 96 6.07937 96 4.36808 95.1281C2.86278 94.3611 1.63893 93.1372 0.871948 91.6319C0 89.9206 0 87.6804 0 83.2V12.8Z"
            fill="#06703B"
            fill-opacity="0.35"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="15"
            y="10"
          >
            <div>
              <span style="font-size:18px; color: #fff;"> สูงสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="15"
            y="45"
          >
            <div>
              <span style="font-size:24px; color: #fff; font-weight: 600;">{{ MAX_WT }} </span>
              <span style="font-size:22px; color: #fff;"> เมตร</span>
            </div>
          </foreignObject>
        </svg>
      </b-col>

      <b-col>
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 128 95"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H115.2C119.68 0 121.921 0 123.632 0.871948C125.137 1.63893 126.361 2.86278 127.128 4.36808C128 6.07937 128 8.31958 128 12.8V82.2C128 86.6804 128 88.9206 127.128 90.6319C126.361 92.1372 125.137 93.3611 123.632 94.1281C121.921 95 119.68 95 115.2 95H12.8C8.31958 95 6.07937 95 4.36808 94.1281C2.86278 93.3611 1.63893 92.1372 0.871948 90.6319C0 88.9206 0 86.6804 0 82.2V12.8Z"
            fill="#FB0000"
            fill-opacity="0.35"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="15"
            y="10"
          >
            <div>
              <span style="font-size:18px; color: #fff;"> ต่ำสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="15"
            y="45"
          >
            <div>
              <span style="font-size:24px; color: #fff; font-weight: 600;"> {{ MIN_WT }} </span>
              <span style="font-size:22px; color: #fff;"> เมตร</span>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>

    <!-- สถานะเรือ -->
    <b-row
      cols="12"
      class="mt-1"
    >
      <b-col
        lg="12"
        md="12"
        sm="6"
        xs="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 405 109"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_b_154_24)">
            <rect
              width="405"
              height="109"
              rx="4"
              fill="#202225"
            />
          </g>
          <defs>
            <filter
              id="filter0_b_154_24"
              x="-36"
              y="-36"
              width="477"
              height="181"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix"
              />
              <feGaussianBlur
                in="BackgroundImageFix"
                stdDeviation="18"
              />
              <feComposite
                in2="SourceAlpha"
                operator="in"
                result="effect1_backgroundBlur_154_24"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_backgroundBlur_154_24"
                result="shape"
              />
            </filter>
          </defs>
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="22"
          >
            <div>
              <b-img
                height="32"
                src="@/assets/images/icons/bridge/Ship.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="75"
            y="22"
          >
            <div>
              <span style="font-size:22px; color: #fff;"> เรือที่มีความสูงเกิน</span>
            </div>
            <span style="font-size:20px; color: #fff;"> สถานะ</span>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="260"
            y="30"
          >
            <div v-if="statusS === 'ปกติ'">
              <b-img
                style="height: 50px;"
                src="@/assets/images/icons/bridge/status/green2.svg"
              />
            </div>
            <div v-if="statusS === 'B'">
              <b-img
                style="height: 50px;"
                src="@/assets/images/icons/bridge/status/yellow2.svg"
              />
            </div>
            <div v-if="statusS === 'C'">
              <b-img
                style="height: 50px;"
                src="@/assets/images/icons/bridge/status/red2.svg"
              />
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,

  },
  directives: {
    Ripple,
  },
  data() {
    return {
      MAX_WT: '',
      MIN_WT: '',
      AVG_WT: '',
      statusS: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getStaticBridge()
    this.getStatusSBridge()
    this.interval = setInterval(() => {
      this.getStaticBridge()
      this.getStatusSBridge()
    }, 300000)
  },
  methods: {
    getStaticBridge() {
      axios
        .post('/waterLevelBridgeDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.MAX_WT = response.data[0].MAX_WT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.MIN_WT = response.data[0].MIN_WT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.AVG_WT = response.data[0].AVG_WT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStatusSBridge() {
      axios
        .post('/wayBridgeDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.statusS = response.data[0].sensor_status
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  </style>
